var exports = {
  "p": "ChannelWelcomeSection.module__channelIcon___NW9MQn",
  "kL": "ChannelWelcomeSection.module__container___NW9MQn",
  "R_": "ChannelWelcomeSection.module__heading___NW9MQn",
  "h_": "ChannelWelcomeSection.module__description___NW9MQn",
  "RK": "ChannelWelcomeSection.module__iconSize___NW9MQn",
};

module.exports = exports;
